import { useEvents } from "api/events";
import { useEffect } from "react";

export function CustomEventFetcher({
  id,
  setListOfFetchedCustomEvents,
}: {
  id: string;
  setListOfFetchedCustomEvents: React.Dispatch<any>;
}) {
  const { useCustomEventSchemaDetails } = useEvents();
  const { data: customEventData } = useCustomEventSchemaDetails(id);

  useEffect(() => {
    if (customEventData) {
      setListOfFetchedCustomEvents(customEventData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customEventData]);

  return null;
}
